import { Navigation } from "lucide-react";

export function mapsUrl(destination: string) {
  return `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(destination)}`;
}

const MapsButton = ({
  destination,
  prominent = false,
}: {
  destination: string;
  prominent?: boolean;
}) => (
  <a
    href={mapsUrl(destination)}
    target="_blank"
    rel="noopener noreferrer"
    onClick={(e) => e.stopPropagation()}
    className={
      prominent
        ? "inline-flex items-center gap-2 rounded-full bg-primary text-primary-foreground px-5 py-2.5 text-xs uppercase tracking-widest font-inter hover:opacity-90 transition-opacity"
        : "inline-flex items-center gap-2 rounded-full border border-primary/40 text-primary px-4 py-2 text-xs uppercase tracking-widest font-inter hover:bg-primary/10 transition-colors"
    }
  >
    <Navigation className="w-3.5 h-3.5" />
    {prominent ? "Directions now" : "Open in Google Maps"}
  </a>
);

export default MapsButton;
